<template>
  <div class="card">
    <div class="card-body">
      <div class="alert alert-warning" role="alert">
        <li>
          Pastikan address yang Anda masukkan adalah address EVM yang benar.
        </li>
        <li>
          Jika terjadi kesalahan pada address, withdrawal mungkin akan dikirim
          ke address yang salah.
        </li>
      </div>

      <form
        @submit.prevent="
          user.two_fa_is_active ? submitWithdrawal() : toggleModalOtp()
        "
      >
        <div class="mt-4">
          <div v-if="travel_rules_element" class="mb-4">
            <div class="row mt-1">
              <div class="col-md-4 text-right">&nbsp;</div>
              <div class="col-md-8">
                <h4 class="text-light">Travel Rules</h4>
              </div>
            </div>
            <div class="row mt-1">
              <label class="col-md-4 text-right">Nama Penerima :</label>
              <div class="col-md-8">
                <input type="text" v-model="wd.to_name" class="form-control" />
              </div>
            </div>

            <div class="row mt-1">
              <label class="col-md-4 text-right">KTP/Passport :</label>
              <div class="col-md-8">
                <input
                  type="text"
                  v-model="wd.to_id_number"
                  class="form-control"
                />
              </div>
            </div>

            <div class="row mt-1">
              <label class="col-md-4 text-right">Alamat Penerima :</label>
              <div class="col-md-8">
                <input
                  type="text"
                  v-model="wd.to_home_address"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-right">Chain ID :</label>
            <div class="col-md-8">
              <select
                v-model="wd.chain_contract"
                class="form-control"
                @change="findFee"
              >
                <option value="" disabled>-- Pilih Network --</option>
                <option
                  v-for="item in evm_tokens"
                  :key="item.id"
                  :value="`${item.chain_id}-${item.contract_address}`"
                >
                  {{ item.chain_id }} - {{ item.contract_address }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-right">Wallet Address :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.withdraw_to"
                class="form-control"
              />
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-right">Jumlah :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.amount"
                class="form-control"
                v-clear-zero
                placeholder="0"
                @keyup="calcAfterFee"
                @keydown="calcAfterFee"
              />
              <small class="text-muted d-block mt-1">
                Minimal withdraw: {{ formattedMinWithdraw }} {{ currency }}
              </small>
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-right">Biaya :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.fee"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-right">Terima Bersih :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="after_fee"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <!-- dengan OTP jika 2FA tidak aktif -->
          <div class="row mt-1" v-if="user.two_fa_is_active == true">
            <label class="col-md-4 text-right">Google Secret :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.google_secret"
                class="form-control"
              />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-4">&nbsp;</div>
            <div class="col-md-8">
              <button
                type="submit"
                class="btn btn-light"
                :disabled="!canSubmit"
              >
                Withdraw
              </button>
              <small
                v-if="isBelowMinWithdraw"
                class="text-warning d-block mt-2"
              >
                Jumlah withdraw minimal {{ formattedMinWithdraw }}
                {{ currency }}
              </small>
              <small
                v-else-if="isInsufficientBalance"
                class="text-warning d-block mt-2"
              >
                Jumlah melebihi saldo tersedia
              </small>
              <small
                v-else-if="user.two_fa_is_active && !hasAuthCode"
                class="text-warning d-block mt-2"
              >
                Google Secret wajib diisi
              </small>

              <ModalOtp v-model:show="isModalOtpShow" @getOtpEvent="getOtp" />
            </div>
          </div>
        </div>
      </form>
      <ModalAmlHold
        :show="showAmlHold"
        :title="amlHoldTitle"
        :body="amlHoldBody"
        @close="onAmlHoldClose"
      />
    </div>
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";
import { useToast } from "vue-toastification";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components
// import BtnRequestOtp from "@/components/global/BtnRequestOtp.vue";
import ModalOtp from "@/components/modals/ModalOtp.vue";
import ModalAmlHold from "@/components/modals/ModalAmlHold.vue";
import { isAmlHold, amlHoldCopy } from "@/applibs/amlHold.js";

const toast = useToast();

export default {
  components: {
    // BtnRequestOtp,
    ModalOtp,
    ModalAmlHold,
  },
  props: {
    currency: {
      type: String,
      required: true,
    },
    ccurrencyObj: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      evm_tokens: [],
      wd: {
        amount: 0,
        otp: "",
        google_secret: "",
        withdraw_to: "",
        chain_contract: "",
        fee: 0,
        to_name: "",
        to_id_number: "",
        to_home_address: "",
      },
      after_fee: 0,
      isModalOtpShow: false,
      showAmlHold: false,
      amlHoldTitle: "",
      amlHoldBody: "",
      availableBalance: 0,

      travel_rules_element: false,
    };
  },

  computed: {
    withdrawAmount() {
      return parseFloat(this.wd.amount) || 0;
    },
    minWithdraw() {
      return parseFloat(this.ccurrencyObj.ccurrency_wd_min_in_idr) || 0;
    },
    formattedMinWithdraw() {
      const decimals = parseInt(this.ccurrencyObj.decimal_display, 10);
      const places = Number.isFinite(decimals) ? decimals : 8;
      return this.minWithdraw.toFixed(places).replace(/\.?0+$/, "") || "0";
    },
    isBelowMinWithdraw() {
      return this.minWithdraw > 0 && this.withdrawAmount < this.minWithdraw;
    },
    isInsufficientBalance() {
      return this.withdrawAmount > (parseFloat(this.availableBalance) || 0);
    },
    hasAuthCode() {
      if (this.user.two_fa_is_active) {
        return String(this.wd.google_secret || "").trim().length > 0;
      }
      // OTP diisi lewat ModalOtp saat submit
      return true;
    },
    canSubmit() {
      return (
        !!this.wd.chain_contract &&
        this.withdrawAmount > 0 &&
        !this.isBelowMinWithdraw &&
        !this.isInsufficientBalance &&
        this.hasAuthCode
      );
    },
  },

  sockets: {
    ubal: function (data) {
      var self = this;
      var obj;
      try {
        obj = typeof data === "string" ? JSON.parse(data) : data;
      } catch (e) {
        return;
      }
      if (!Array.isArray(obj)) {
        obj = [obj];
      }
      obj.forEach(function (el) {
        if (!el || parseInt(self.usid, 10) !== parseInt(el.u, 10)) {
          return;
        }
        if (el[self.currency] != null) {
          self.availableBalance = el[self.currency];
        }
      });
    },
  },

  async mounted() {
    var self = this;
    // ambil semua network yang di support oleh ini
    await self.getEvmTokenAddress();
    await self.getAvailableBalance();
  },

  methods: {
    async getEvmTokenAddress() {
      var self = this;
      var res = await thestore.getEvmTokensByCcurrencyId(self.ccurrencyObj.id);
      self.evm_tokens = res.filter((token) => token.tracking); // Filter hanya tampilkan yang tracking = true
    },

    async getAvailableBalance() {
      var self = this;
      var filter_rules = [
        { field: "ccurrency_symbol", op: "equal", value: self.currency },
      ];
      var res = await thestore.getBalances(
        self.token,
        1,
        1,
        "id",
        "asc",
        filter_rules
      );
      if (res.datas && res.datas[0]) {
        self.availableBalance = res.datas[0].saldo_value;
      }
    },

    async submitWithdrawal() {
      // validasi untuk setiap kolom form harus diisi jika tidak fungsi akan break
      let isValid = this.formValidate();

      if (!isValid) {
        return { success: false, validationError: true };
      }

      var self = this;

      // karena selectnya tidak kita buat :value, maka kita parsing saja isiannya
      var chain_contract = self.wd.chain_contract.split("-");

      if (parseFloat(self.wd.amount) >= self.ccurrencyObj.travel_rules_limit) {
        if (
          self.wd.to_name == "" ||
          self.wd.to_id_number == "" ||
          self.wd.to_home_address == ""
        ) {
          alert("Anda wajib mengisi nama dan alamat penerima");
          return { success: false, validationError: true };
        }
      }

      var res_a = await thestore.postEvmTokenWithdraw(
        self.token,
        self.wd.otp,
        self.wd.google_secret,
        chain_contract[0],
        chain_contract[1],
        self.currency,
        self.wd.amount,
        self.wd.withdraw_to,
        self.wd.to_name,
        self.wd.to_id_number,
        self.wd.to_home_address
      );
      if (res_a.success == true) {
        if (isAmlHold(res_a)) {
          const copy = amlHoldCopy(res_a);
          self.amlHoldTitle = copy.title;
          self.amlHoldBody = copy.body;
          self.showAmlHold = true;
        } else {
          alert(
            "Kami akan memproses permintaan penarikan Anda. Mohon tunggu beberapa saat."
          );
          self.$router.go();
        }
      } else {
        alert(res_a.msg);
      }

      return {
        success: res_a.success,
        msg: res_a.msg,
        message: res_a.msg || res_a.message,
      };
    },

    calcAfterFee() {
      var self = this;
      self.after_fee = parseFloat(self.wd.amount) - parseFloat(self.wd.fee);

      if (parseFloat(self.wd.amount) >= self.ccurrencyObj.travel_rules_limit) {
        self.travel_rules_element = true;
      } else {
        self.travel_rules_element = false;
      }
    },

    findFee() {
      var self = this;

      var chain_contract = self.wd.chain_contract.split("-");

      // cari chain object yang dipilih
      var chainObj = self.evm_tokens.find(
        (u) => parseInt(u.chain_id) === parseInt(chain_contract[0])
      );

      self.wd.fee = chainObj.wd_fee;

      self.calcAfterFee();
    },

    toggleModalOtp() {
      // validasi untuk setiap kolom form harus diisi jika tidak fungsi akan break
      let isValid = this.formValidate();

      if (!isValid) {
        return;
      }

      // toggle untuk modal OTP jika 2FA disable
      if (!this.user.two_fa_is_active)
        this.isModalOtpShow = !this.isModalOtpShow;
    },

    onAmlHoldClose() {
      this.showAmlHold = false;
      this.$router.go();
    },

    async getOtp(code, callback) {
      this.wd.otp = code;
      const result = await this.submitWithdrawal();

      if (callback && result) {
        callback(result);
      }
    },

    formValidate() {
      if (!this.wd.chain_contract) {
        toast.warning("Pilih network terlebih dahulu");
        return false;
      }

      if (!this.wd.withdraw_to || !this.wd.amount) {
        toast.warning("Kolom tidak boleh kosong");
        return false;
      }

      if (this.isInsufficientBalance) {
        toast.warning("Jumlah melebihi saldo tersedia");
        return false;
      }

      if (this.isBelowMinWithdraw) {
        toast.warning(
          `Jumlah withdraw minimal ${this.formattedMinWithdraw} ${this.currency}`
        );
        return false;
      }

      if (this.user.two_fa_is_active && !this.hasAuthCode) {
        toast.warning("Google Secret wajib diisi");
        return false;
      }

      return true;
    },
  },
};
</script>
